import React from 'react';
import { CommonPrelanderV49 } from '../../components/CommonPrelanderV49';
import { QUIZ_SLIDES_V38 } from '../../shared/quiz-slides/quiz-slides-v38';

function PrelanderV58Page({ initialPrelander }) {
    return (
        <CommonPrelanderV49
            initialPrelander={initialPrelander}
            quizSlides={QUIZ_SLIDES_V38}
        />
    );
}

export {
    PrelanderV58Page
};
